import XLSX from "xlsx";
import axios from "axios";
import firebase from "firebase";
import db from "../components/firebaseInit";
import store from "../store";
import moment from "moment";
import APIs from "@/components/APIInit";
import { bus } from "@/main";
//import { Random } from "random-js";



//const client_collectionName = "OA_UAT";
//const event_collectionName = "OA_UAT_C1591205467009E1591206650065";//hpclient@hp.com
//const event_collectionName = "OA_UAT_C1591904892446E1591907102804";//ergoclient@ergo.co.in
//const event_collectionName = "OA_UAT_C1592010308300E1592010479212"; //cgclientadmin@cg.com

//var FirebaseAuthApi = APIs.FirebaseAuthApi;

//console.log("store====================",vm.$store.state);




var CreateGroupAPI = APIs.CreateGroupAPI;
//var SessionAttendeeMappingAPI = APIs.SessionAttendeeMappingAPI;
var AddSingleAttendeeAPI = APIs.AddSingleAttendeeAPI;
var AddMultipleAttendeeAPI = APIs.RegisterEventAttendee;
var DeleteAttendeeApiKey = APIs.DeleteAttendeeApiKey;
var CheckUserValidAPI = APIs.CheckUserValidAPI;
var UpdateUserAPI = APIs.UpdateUserAPI;
var RequestMultipleMeeting = APIs.RequestMultipleMeeting;
var Session_Client_Id = store.getters.getClientId;
var InviteAttendeeApiURL = APIs.InviteAttendeeApiURL;

var SessionToken = store.getters.getToken;

var Session_Event_Id = store.getters.getEvent;
//var Session_UserId = ls.getSessionValueByKey("UserId")
const value_row_start = 3;
const column_row = 2;
let generalRTCapacity = 12;
let maxRTCapacity = 12;
let attendeeList = [];
let speakerList = [];
let roundTableTopicList = [];
let sessionTrackList = [];
let sessionLocationList = [];
//GetAutoID('user')
//let clientId = ls.getSessionValueByKey("Session_Client_Id");
//let eventId = ls.getSessionValueByKey("Session_Event_Id");
let Session_Event_TZ = store.getters.getZone;

//let event_collectionName = ls.getSessionEventCollectionName();


let requiredColumns = {
    'notification': ["NotificationTitle", "IsScheduled", "Date", "Message", "AllUsers", "Group", "Attendee"],
    'sponsor': ["Name", "Category", "Booth No", "Logo", "Hotspot Image URL", "Showcase Video URL", "Showcase Images", "Email", "Phone", "Website", "Profile", "Facebook", "LinkedIn", "Twitter", "Instagram", "Mapped Attendees", "Resource File URL"],
    'roundtable': ["Table ID", "Table Name", "Group Name", "Spectator Mode", "Pre-Assigned", "Mapped Attendees", "Host"],
    'exhibitor': ["Name", "Category", "Booth No", "Logo", "Hotspot Image URL", "Showcase Video URL", "Showcase Images", "Email", "Phone", "Website", "Profile", "Facebook", "LinkedIn", "Twitter", "Instagram", "Mapped Attendees", "Resource File URL"],
    'speaker': ["First Name", "Last Name", "Email", "Phone", "Company", "Title", "Profile", "Profile Picture URL", "Group", "Website", "Facebook", "LinkedIn", "Twitter", "Instagram", "Resource File URL"],
    'attendee': ["First Name", "Last Name", "Email", "Phone", "Company", "Title", "Profile", "Profile Picture URL", "Website", "Facebook", "LinkedIn", "Twitter", "Instagram"],
    'session': ["Session ID", "Session Name", "Track Name", "Location", "Start Date", "End Date", "Short Description", "Long Description", "Mapped Speakers", "Mapped Hosts", "Resource File URL", "Session Type"],
    'group': ["Email", "GroupName"],
    'meeting': ["Meeting Date", "Meeting Start Time", "Meeting Requested By", "Meeting Requested To", "Meeting Purpose", "Status"],
    'invitee': ["First Name", "Last Name", "Email"]

}
//let vm = exports;
let vm = {
    clientId: store.getters.getClientId,
    eventId: store.getters.getEvent,
    event_collectionName: store.getters.getEventCollectionName,
    vs: null,
    map_attendees: [],
    GenerateAutoId: function (entityName) {
        console.log("1-------------");
        var autoId = "";
        if (entityName != undefined && entityName != null && entityName != "") {
            //switch (entityName) {
            //  case "attendee":
            //    break;
            //}
            autoId = new Date().getTime().toString();
        }
        return autoId;
    },
    initVueComps: function (vs) {
        console.log("2-------------");
        vm.vs = vs
    },
    StartUploadPrecss: function (files, uploadFrom) {
        console.log("3-------------");

        if (!files.length) {
            alert("Please Upload File!");
            return;
        } else {
            // var validSheetNames = [
            //     "notification",
            //     "attendee",
            //     "speaker",
            //     "sponsor",
            //     "exhibitor",
            //     "roundtable",
            //     "session",
            //     "group"
            // ];
            debugger;

            var validFileTypes = [
                ".csv",
                "csv",
                ".xlsx",
                "xlsx",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel"
            ];
            var f = files[0];
            var ext = f.name.split(".")[f.name.split(".").length - 1];
            if (!validFileTypes.includes(f.type) && !validFileTypes.includes(ext)) {
                alert("Only csv,excel file allowed.");
                return false;
            }

            var reader = new FileReader();
            reader.onload = function (e) {
                var data = new Uint8Array(e.target.result);
                var workbook = XLSX.read(data, { type: "array" });
                debugger;
                for (var i = 0; i < workbook.SheetNames.length; i++) {
                    let sheetName = workbook.SheetNames[i];
                    /*if (!validSheetNames.includes(sheetName.toLowerCase())) {
                      alert(
                        "Sheet Name " +
                          sheetName +
                          " does not belongs to " +
                          validSheetNames.toString().toUpperCase()
                      );
                    }*/
                    console.log("sheetName====", sheetName.toLowerCase());
                    console.log("uploadFrom====", uploadFrom.toLowerCase());

                    if (sheetName.toLowerCase() == uploadFrom.toLowerCase()) {
                        let worksheet = workbook.Sheets[sheetName];
                        let dataJson = XLSX.utils.sheet_to_json(worksheet, {
                            header: 1,
                            defval: "",
                            blankrows: false
                        });
                        let returnArr = vm.readExcel(sheetName.toLowerCase(), dataJson);
                        if (returnArr) {
                            let dataList = returnArr[0]
                            let invalid_rows = returnArr[1]
                            let invalid_date_rows = returnArr[2]
                            let invalid_fname_rows = returnArr[3]
                            let invalid_name_rows = returnArr[4]
                            let invalid_tname_rows = returnArr[5]
                            let invalid_sname_rows = returnArr[6]
                            let invalid_host_rows = returnArr[7]
                            let invalid_groupname_rows = returnArr[8]
                            let max_host_exceed = returnArr[9]
                            let max_guest_exceed = returnArr[10]
                            if (invalid_rows.length) {
                                if (confirm(sheetName + " has invalid Email row : " + JSON.stringify(invalid_rows) + "\nDo you want to continue?")) {
                                    vm.IterateAndCreateList(sheetName.toLowerCase(), dataList, 0);
                                }
                            } else if (invalid_date_rows.length) {
                                if (confirm(sheetName + " has invalid Date row : " + JSON.stringify(invalid_date_rows) + "\nDo you want to continue?")) {
                                    vm.IterateAndCreateList(sheetName.toLowerCase(), dataList, 0);
                                }
                            } else if (invalid_fname_rows.length) {
                                if (confirm(sheetName + " has invalid First Name row : " + JSON.stringify(invalid_fname_rows) + "\nDo you want to continue?")) {
                                    vm.IterateAndCreateList(sheetName.toLowerCase(), dataList, 0);
                                }
                            } else if (invalid_name_rows.length) {
                                if (confirm(sheetName + " has invalid Name row : " + JSON.stringify(invalid_name_rows) + "\nDo you want to continue?")) {
                                    vm.IterateAndCreateList(sheetName.toLowerCase(), dataList, 0);
                                }
                            } else if (invalid_tname_rows.length) {
                                if (confirm(sheetName + " has invalid Table Name row : " + JSON.stringify(invalid_tname_rows) + "\nDo you want to continue?")) {
                                    vm.IterateAndCreateList(sheetName.toLowerCase(), dataList, 0);
                                }
                            } else if (invalid_sname_rows.length) {
                                if (confirm(sheetName + " has invalid Session Name row : " + JSON.stringify(invalid_sname_rows) + "\nDo you want to continue?")) {
                                    vm.IterateAndCreateList(sheetName.toLowerCase(), dataList, 0);
                                }
                            } else if (invalid_host_rows.length) {
                                if (confirm(sheetName + " has invalid Host row : " + JSON.stringify(invalid_host_rows) + "\nDo you want to continue?")) {
                                    vm.IterateAndCreateList(sheetName.toLowerCase(), dataList, 0);
                                }
                            } else if (invalid_groupname_rows.length) {
                                if (confirm(sheetName + " has invalid Group Name row : " + JSON.stringify(invalid_groupname_rows) + "\nDo you want to continue?")) {
                                    vm.IterateAndCreateList(sheetName.toLowerCase(), dataList, 0);
                                }
                            }
                            else if (max_host_exceed.length) {
                                if (confirm(sheetName + " Host exceeds limit, row : " + JSON.stringify(max_host_exceed) + "\nDo you want to continue?")) {
                                    vm.IterateAndCreateList(sheetName.toLowerCase(), dataList, 0);
                                }
                            }
                            else if (max_guest_exceed.length) {
                                if (confirm(sheetName + " Mapped Attendees exceeds limit, row : " + JSON.stringify(max_guest_exceed) + "\nDo you want to continue?")) {
                                    vm.IterateAndCreateList(sheetName.toLowerCase(), dataList, 0);
                                }
                            }
                            else if (dataList.length) {
                                vm.IterateAndCreateList(sheetName.toLowerCase(), dataList, 0);
                            } else {
                                alert("No data to import in sheet " + sheetName);
                            }
                        }
                    }
                    /*else if(sheetName.toLowerCase() != 'help')
                    {              
                      alert("Incorrect template used: Please use the correct template to upload data!");
                    }*/
                }
            }
            reader.readAsArrayBuffer(f);
        }
    },
    readExcel: function (sheetName, dataXL) {
        console.log("4-------------");
        console.log("sheetName=====", sheetName);
        console.log("dataXL=====", dataXL);

        debugger;
        let colums = dataXL[column_row];
        colums = colums.map(s => s.trim());
        //console.log(JSON.stringify(colums));
        var dataList = [];
        var inavalid_dataList = [];
        let invalid_rows = [];
        let invalid_date_rows = [];
        let invalid_fname_rows = [];
        let invalid_name_rows = [];
        let invalid_tname_rows = [];
        let invalid_sname_rows = [];
        let invalid_host_rows = [];
        let invalid_groupname_rows = [];
        let max_host_exceed = []
        let max_guest_exceed = []
        let returnArray = []

        debugger;


        let notfoundcols = []
        for (let i = 0; i < requiredColumns[sheetName].length; i++) {
            if (!colums.includes(requiredColumns[sheetName][i].trim())) {
                //console.log(requiredColumns[sheetName][i])
                notfoundcols.push(requiredColumns[sheetName][i])
            }
        }

        if (colums.length < requiredColumns[sheetName].length) {
            alert("Uploaded files columns does not match to required columns!");
            return false;
        }

        if (notfoundcols.length) {
            alert("Uploaded files columns does not exist! : " + JSON.stringify(notfoundcols));
            return false;
        }
        for (var i = value_row_start; i < dataXL.length; i++) {
            let noerror = true;
            let row = dataXL[i];
            var rowObj = new Object();
            for (var j = 0; j < row.length; j++) {
                rowObj[colums[j]] = row[j];
            }
            if (rowObj.Email == "") {
                rowObj["row"] = i;
                invalid_rows.push(i + 2);
                inavalid_dataList.push(rowObj);
                noerror = false;
            }
            if (rowObj['First Name'] == "") {
                invalid_fname_rows.push(i + 2);
                noerror = false;
            }
            if (rowObj['Name'] == "") {
                invalid_name_rows.push(i + 2);
                noerror = false;
            }
            if (rowObj['Table Name'] == "") {
                invalid_tname_rows.push(i + 2);
                noerror = false;
            }
            if (rowObj['Session Name'] == "") {
                invalid_sname_rows.push(i + 2);
                noerror = false;
            }

            if (rowObj['Host'] == "") {
                invalid_host_rows.push(i + 2);
                noerror = false;
            }
            if (rowObj["Host"]) {
                let mappedHostArr = rowObj["Host"].split(",");
                if (mappedHostArr.length > 1) {
                    max_host_exceed.push(i + 2);
                    noerror = false;
                }
            }
            /*if (rowObj["Mapped Attendees"]) {
                let mappedGuestArr = rowObj["Mapped Attendees"].split(",");
                if (mappedGuestArr.length > RTMappedAttendees) {
                    max_guest_exceed.push(i + 2);
                    noerror = false;
                }
            }*/

            if (rowObj['Start Date'] != undefined || rowObj['End Date'] != undefined) {
                if (moment(rowObj['Start Date'], 'YYYY/MM/DD HH:mm', true).isValid() && moment(rowObj['End Date'], 'YYYY/MM/DD HH:mm', true).isValid()) {
                    console.log("test");
                } else {
                    invalid_date_rows.push(i + 2);
                    noerror = false;
                }
            }

            if (rowObj['GroupName'] == "") {
                invalid_groupname_rows.push(i + 2);
                noerror = false;
            }

            if (noerror) {
                dataList.push(rowObj);
            }
        }


        /*if (inavalid_dataList.length) {
          console.log(
            sheetName + " has invalid row : " + JSON.stringify(inavalid_dataList)
          );
        }*/
        returnArray.push(dataList)
        returnArray.push(invalid_rows)
        returnArray.push(invalid_date_rows)
        returnArray.push(invalid_fname_rows)
        returnArray.push(invalid_name_rows)
        returnArray.push(invalid_tname_rows)
        returnArray.push(invalid_sname_rows)
        returnArray.push(invalid_host_rows)
        returnArray.push(invalid_groupname_rows)
        returnArray.push(max_host_exceed)
        returnArray.push(max_guest_exceed)
        return returnArray;
    },
    IterateAndCreateList: function (sheetName, rowlist, batchId) {
        console.log("5-------------");
        if (batchId == 0) {
            var docObj = new Object();
            db.collection("OA_UAT")
                .doc("AutoID")
                .get()
                .then(function (doc) {
                    //debugger;
                    if (!doc.exists) {
                        docObj.UserId = 0;
                        db.collection("OA_UAT")
                            .doc("AutoID")
                            .set(docObj)
                            .then(function () {
                                console.log("AutoID Created : ");
                                vm.IterateAndCreateList(sheetName, rowlist, 0);
                            })
                            .catch(function (error) {
                                console.error("Error creating Sessions: ", error);
                            });
                    } else {
                        //console.log('exist- '+docObj.Email);
                        //data.AttendeeId.substr(data.AttendeeId.length - 8);
                        //var tempAutoId = doc.data().UserId;
                        //if(tempAutoId.length>3)
                        //{
                        //var rightId=tempAutoId.substr(tempAutoId.length - 3);
                        //tempAutoId=tempAutoId.replace(0,)
                        //}
                        //batchId = doc.data().UserId + 1;
                        db.collection("OA_UAT")
                            .doc("AutoID")
                            .update({
                                UserId: firebase.firestore.FieldValue.increment(1)
                            })
                            .then(function () {
                                //debugger;
                                db.collection("OA_UAT")
                                    .doc("AutoID")
                                    .get()
                                    .then(function (doc) {
                                        //debugger;
                                        if (doc.exists) {
                                            //debugger;
                                            vm.IterateAndCreateList(
                                                sheetName,
                                                rowlist,
                                                doc.data().UserId
                                            );
                                        }
                                    });
                                console.log("Sessions Updated : ");
                            })
                            .catch(function (error) {
                                console.error("Error creating Sessions: ", error);
                            });
                    }
                    //alert("Sessions Created Successfully");
                })
                .catch(function (error) {
                    console.log("Error saving Sessions:", error);
                });
        }
        //debugger;
        if (batchId == 0) {
            return;
        }


        if (vm.vs && rowlist.length) {
            // vm.vs.loading();
            bus.$emit("toggleLoader", true);
        }
        let countRecordDone = 0;
        let returnval = "";
        //debugger;
        //var autoId = (batchId - 1) * 1000 + 1;
        var autoId = batchId * 1000;
        switch (sheetName) {

            case "meeting": {
                let map_meetings = [];
                for (let i = 0; i < rowlist.length; i++) {
                    if (i == 50) {
                        alert("Maximum 50 records allowed to import.");
                        break;
                    }
                    let date = moment(`${rowlist[i]["Meeting Date"]} ${rowlist[i]["Meeting Start Time"]}`, 'MM-DD-YYYY H:m').tz(Session_Event_TZ).utc().format();
                    let rowObj = {
                        "RequestorEmail": rowlist[i]["Meeting Requested By"],
                        "RequestorTimezone": Session_Event_TZ,
                        "InviteeEmail": rowlist[i]["Meeting Requested To"],
                        "InviteeTimezone": Session_Event_TZ,
                        "Slots": [date],
                        "Status": rowlist[i]["Status"],
                        "Message": rowlist[i]["Meeting Purpose"],
                        "MeetingType": "one2one",
                        "Subject": "One to One Meeting"
                    }
                    map_meetings.push(rowObj);

                }
                let requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id
                    },
                    "data": map_meetings
                }
                let headers = {
                    'Authorization': `Bearer ` + vm.getSessionToken(),
                    "content-type": "application/json"
                }
                axios.post(RequestMultipleMeeting, requestData, { headers: headers }).then((response) => {
                    //console.log(response)
                    if (vm.vs)
                        bus.$emit("toggleLoader", false);
                    //vm.vs.loading.close();
                    if (response.data.status == 0) {
                        alert("Meeting Uploaded");
                        window.location.reload();
                    }
                    else
                        alert("Meeting  Not Uploaded!")
                }).catch((error) => {
                    console.log(error)
                    alert("Something Went Wrong!")
                    if (vm.vs)
                        //vm.vs.loading.close();
                        bus.$emit("toggleLoader", false);
                })
                map_meetings = []
                returnval = sheetName + " uploaded";
                break;
            }


            case "group": {
                let map_attendees = [];
                let Group = null;
                for (let i = 0; i < rowlist.length; i++) {
                    if (i == 999) {
                        alert("Maximum 999 records allowed to import.");
                        break;
                    }
                    vm.CreateGroupAndMap(rowlist[i]).then(function (res) {
                        countRecordDone = countRecordDone + 1;
                        if (res.attendee) {
                            map_attendees.push(res.attendee);
                            Group = res.Group
                        }
                        if (countRecordDone == rowlist.length) {

                            let field = {
                                attendee_list: map_attendees,
                                Group: Group
                            }
                            vm.mapAttendeestoGroup(field).then(res => {
                                if (vm.vs) {
                                    //vm.vs.loading.close();
                                    bus.$emit("toggleLoader", false);
                                }
                                if (res.status == 200) {
                                    alert("Successful Upload: " + countRecordDone + " out of " + rowlist.length + " Group & Attendee Imported successfully!");
                                    window.location.reload();
                                }
                                else {
                                    alert("Attendee not Mapped to Group!")
                                }
                            })

                        }
                    });
                }
                returnval = sheetName + " uploaded";
                break;
            }


            case "notification": {
                debugger;
                for (let i = 0; i < rowlist.length; i++) {
                    if (i == 999) {
                        alert("Maximum 999 records allowed to import.");
                        break;
                    }
                    var docId = autoId.toString();
                    debugger;
                    vm.CreateNotification(rowlist[i]).then(function (res) {
                        console.log(res);
                        countRecordDone = countRecordDone + 1;
                        if (countRecordDone == rowlist.length) {
                            if (vm.vs) {
                                //vm.vs.loading.close();
                                bus.$emit("toggleLoader", false);
                            }
                            alert("Successful Upload: " + countRecordDone + " out of " + rowlist.length + " Notification Imported successfully!")
                            window.location.reload();
                        }
                    });
                    autoId++;
                }
                returnval = sheetName + " uploaded";
                break;
            }

            case "attendee": {
                let attendees = [];
                for (let i = 0; i < rowlist.length; i++) {
                    if (i == 999) {
                        alert("Maximum 999 records allowed to import.");
                        break;
                    }
                    docId = autoId.toString();
                    //vm.CreateAttendeeAndUser(rowlist[i], docId, false).then(function(res) {
                    vm.ProcessAttendeeObj(rowlist[i]).then(function (attendeeObj) {
                        countRecordDone = countRecordDone + 1;
                        attendees.push(attendeeObj);
                        if (countRecordDone == rowlist.length) {
                            vm.AddMultipleAttendee(attendees).then(res => {
                                if (vm.vs) {
                                    // vm.vs.loading.close();
                                    bus.$emit("toggleLoader", false);
                                }
                                if (res.status == 200) {
                                    alert("Successful Upload: " + countRecordDone + " out of " + rowlist.length + " Attendee Imported successfully!")
                                    window.location.reload();
                                }
                                else {
                                    alert("Attendee not uploaded!")
                                }
                            })
                        }
                    });
                    autoId++;
                }
                returnval = sheetName + " uploaded";
                break;
            }

            case "speaker": {
                for (let i = 0; i < rowlist.length; i++) {
                    if (i == 999) {
                        alert("Maximum 999 records allowed to import.");
                        break;
                    }
                    //docId = "0000000" + autoId.toString();
                    docId = autoId.toString();
                    //docId = docId.substr(docId.length - 8);
                    vm.CreateSpeaker(rowlist[i], docId, false).then(function (res) {
                        console.log(res);
                        countRecordDone = countRecordDone + 1;
                        if (countRecordDone == rowlist.length) {
                            if (vm.vs) {
                                //vm.vs.loading.close();
                                bus.$emit("toggleLoader", false);
                            }
                            alert("Successful Upload: " + countRecordDone + " out of " + rowlist.length + " Speaker Imported successfully!")
                            window.location.reload();
                        }
                    });
                    autoId++;
                }
                returnval = sheetName + " uploaded";
                break;
            }

            case "invitee": {
                let attendees = [];
                for (let i = 0; i < rowlist.length; i++) {
                    if (i == 999) {
                        alert("Maximum 999 records allowed to import.");
                        break;
                    }
                    docId = autoId.toString();
                    //vm.CreateAttendeeAndUser(rowlist[i], docId, false).then(function(res) {
                    vm.ProcessInviteeObj(rowlist[i]).then(function (attendeeObj) {
                        countRecordDone = countRecordDone + 1;
                        attendees.push(attendeeObj);
                        if (countRecordDone == rowlist.length) {
                            console.log("attendees=======", attendees);
                            vm.AddMultipleInvitee(attendees).then(res => {
                                if (vm.vs) {
                                    // vm.vs.loading.close();
                                    bus.$emit("toggleLoader", false);
                                }
                                if (res.status == 200) {
                                    console.log("res====", res);
                                    alert("Successful Upload: " + countRecordDone + " out of " + rowlist.length + " Attendee Imported successfully!")
                                    window.location.reload();
                                }
                                else {
                                    alert("Attendee not uploaded!")
                                }
                            })
                        }
                    });
                    autoId++;
                }
                returnval = sheetName + " uploaded";
                break;
            }

            case "sponsor": {
                db.eventDB
                    .collection(vm.event_collectionName)
                    .doc("AttendeeList")
                    .collection("Attendees")
                    .get()
                    .then(querySnapshot => {
                        attendeeList = [];
                        querySnapshot.forEach(doc => {
                            attendeeList.push(doc);
                        });
                        //Start Add Sponsor
                        for (let i = 0; i < rowlist.length; i++) {
                            if (i == 999) {
                                alert("Maximum 999 records allowed to import.");
                                break;
                            }
                            //docId = "0000000" + autoId.toString();
                            docId = autoId.toString();
                            //docId = docId.substr(docId.length - 8);
                            vm.CreateSponsor(rowlist[i], docId).then(function (res) {
                                console.log(res);
                                countRecordDone = countRecordDone + 1;
                                if (countRecordDone == rowlist.length) {
                                    if (vm.vs) {
                                        // vm.vs.loading.close();
                                        bus.$emit("toggleLoader", false);
                                    }
                                    alert("Successful Upload: " + countRecordDone + " out of " + rowlist.length + " Sponsor Imported successfully!")
                                    window.location.reload();
                                }
                            });
                            autoId++;
                        }
                    });

                returnval = sheetName + " uploaded";
                break;
            }

            case "exhibitor": {
                db.eventDB
                    .collection(vm.event_collectionName)
                    .doc("AttendeeList")
                    .collection("Attendees")
                    .get()
                    .then(querySnapshot => {
                        attendeeList = [];
                        querySnapshot.forEach(doc => {
                            attendeeList.push(doc);
                        });

                        for (let i = 0; i < rowlist.length; i++) {
                            if (i == 999) {
                                alert("Maximum 999 records allowed to import.");
                                break;
                            }
                            //docId = "0000000" + autoId.toString();
                            docId = autoId.toString();
                            //docId = docId.substr(docId.length - 8);
                            vm.CreateExhibitor(rowlist[i], docId).then(function (res) {
                                console.log(res);
                                countRecordDone = countRecordDone + 1;
                                if (countRecordDone == rowlist.length) {
                                    if (vm.vs) {
                                        // vm.vs.loading.close();
                                        bus.$emit("toggleLoader", false);
                                    }
                                    alert("Successful Upload: " + countRecordDone + " out of " + rowlist.length + " Exhibitor Imported successfully!")
                                    window.location.reload();
                                }
                            });
                            autoId++;
                        }
                    });
                returnval = sheetName + " uploaded";
                break;
            }

            case "roundtable": {
                db.eventDB
                    .collection(vm.event_collectionName)
                    .doc("AttendeeList")
                    .collection("Attendees")
                    .get()
                    .then(querySnapshot => {
                        attendeeList = [];
                        querySnapshot.forEach(doc => {
                            attendeeList.push(doc);
                        });

                        db.eventDB
                            .collection(vm.event_collectionName)
                            .doc("RoundTableTopicList")
                            .collection("RoundTableTopics")
                            .get()
                            .then(querySnapshotTopic => {
                                roundTableTopicList = [];
                                querySnapshotTopic.forEach(docTopic => {
                                    roundTableTopicList.push(docTopic);
                                });

                                for (let i = 0; i < rowlist.length; i++) {
                                    if (i == 999) {
                                        alert("Maximum 999 records allowed to import.");
                                        break;
                                    }
                                    //docId = "0000000" + autoId.toString();
                                    docId = autoId.toString();
                                    //docId = docId.substr(docId.length - 8);
                                    vm.CreateRoundTable(rowlist[i], docId).then(function (res) {
                                        console.log(res);
                                        countRecordDone = countRecordDone + 1;
                                        if (countRecordDone == rowlist.length) {
                                            if (vm.vs) {
                                                //vm.vs.loading.close();
                                                bus.$emit("toggleLoader", false);
                                            }
                                            alert("Successful Upload: " + countRecordDone + " out of " + rowlist.length + " Roundtable Imported successfully!")
                                            window.location.reload();
                                        }
                                    });
                                    autoId++;
                                }
                            });
                    });
                returnval = sheetName + " uploaded";
                break;
            }

            case "session": {
                db.eventDB
                    .collection(vm.event_collectionName)
                    .doc("SpeakerList")
                    .collection("Speakers")
                    .get()
                    .then(querySnapshot => {
                        speakerList = [];
                        querySnapshot.forEach(doc => {
                            speakerList.push(doc);
                        });

                        db.eventDB
                            .collection(vm.event_collectionName)
                            .doc("TrackList")
                            .collection("Tracks")
                            .get()
                            .then(querySnapshotTrack => {
                                sessionTrackList = [];
                                querySnapshotTrack.forEach(docTrack => {
                                    sessionTrackList.push(docTrack);
                                });

                                db.eventDB
                                    .collection(vm.event_collectionName)
                                    .doc("LocationList")
                                    .collection("Locations")
                                    .get()
                                    .then(querySnapshotLocation => {
                                        sessionLocationList = [];
                                        querySnapshotLocation.forEach(docLocation => {
                                            sessionLocationList.push(docLocation);
                                        });


                                        for (let i = 0; i < rowlist.length; i++) {
                                            if (i == 999) {
                                                alert("Maximum 999 records allowed to import.");
                                                break;
                                            }
                                            //docId = "0000000" + autoId.toString();
                                            docId = autoId.toString();
                                            //docId = docId.substr(docId.length - 8);
                                            vm.CreateSession(rowlist[i], docId).then(function (res) {
                                                console.log(res);
                                                countRecordDone = countRecordDone + 1;
                                                if (countRecordDone == rowlist.length) {
                                                    if (vm.vs) {
                                                        // vm.vs.loading.close();
                                                        bus.$emit("toggleLoader", false);

                                                    }
                                                    alert("Successful Upload: " + countRecordDone + " out of " + rowlist.length + " Session Imported successfully!")
                                                    window.location.reload();
                                                }
                                            });
                                            autoId++;
                                        }
                                    });
                            });
                    });
                returnval = sheetName + " uploaded";
                break;
            }

            default:
                returnval = sheetName + " work in progress!";
        }
        return returnval;
    },
    CreateGroupAndMap: function (row) {
        console.log("6-------------");
        return new Promise((resolve, reject) => {
            if (row["GroupName"] && row["Email"]) {
                let GroupName = row["GroupName"] != "" ? row["GroupName"].trim() : ""
                let Email = row["Email"] != "" ? row["Email"].trim() : ""
                vm.addGroup({ GroupName: GroupName }).then(response => {
                    if (response.status == 200) {
                        vm.getAttendeeDetailbyEmail(Email).then(userDetail => {
                            if (userDetail) {

                                let field = {
                                    attendee: {
                                        AttendeeId: String(userDetail.AttendeeId),
                                        Name: userDetail.Name ? userDetail.Name : null,
                                        FirstName: userDetail.FirstName,
                                        LastName: userDetail.LastName,
                                        Email: userDetail.Email
                                    },
                                    Group: response.Group
                                }
                                resolve(field)
                            }
                            else {
                                resolve(null)
                            }
                        })
                    }
                    else {
                        vm.vs.notify({
                            color: "warning",
                            position: "top-center",
                            fixed: true,
                            title: "Attendee not mapped",
                            text: "Group not Exists : " + GroupName
                        })
                        resolve("Group not created!")
                    }
                })
            }
            else {
                console.log("Group & Email Needed!")
                reject("Group & Email Needed!")
            }
        });
    },
    addGroup: function (field) {
        console.log("7-------------");
        return new Promise((resolve) => {
            let groupRef = db.eventDB.collection(vm.event_collectionName).doc("GroupList").collection("Groups")
            groupRef.where("GroupName", "==", field.GroupName).get().then(snapShot => {
                console.log("checking group")
                if (snapShot.docs.length) {
                    let doc = snapShot.docs[0]
                    resolve({ status: 200, message: "group exists", Group: doc.data() })
                }
                else {
                    resolve({ status: 500, message: "group not exists" })
                }
            })
        })
    },
    mapAttendeestoGroup: function (field) {
        console.log("8-------------");
        return new Promise((resolve) => {
            vm.getFirebaseAccessToken().then(accessToken => {
                console.log(accessToken);
                let headers = {
                    'Authorization': `Bearer ` + vm.getSessionToken(),
                    "content-type": "application/json"
                }

                let requestData = {
                    "source": "web",
                    //"token": `${accessToken}`,
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id
                    },
                    "data": {
                        "groups": [{
                            "GroupId": `${field.Group.GroupId}`,
                            "GroupName": `${field.Group.GroupName}`
                        }],
                        "map": {
                            "attendees": field.attendee_list
                        }
                    }
                }

                axios.put(CreateGroupAPI, requestData, { headers: headers }).then((response) => {
                    console.log(response)
                    resolve({ status: 200, message: "Attendees Mapped to group" })
                }).catch((error) => {
                    console.log(error)
                    resolve({ status: 500, message: "Attendees not Mapped to group" })
                })
            })
            //})

        })
    },
    getFirebaseAccessToken: function () {
        console.log("9-------------");
        return new Promise((resolve) => {
            let accessToken = this.$store.state.token;
            resolve(accessToken);
        })
    },
    getAttendeeDetailbyEmail: function (Email) {
        console.log("10-------------");
        return new Promise((resolve) => {
            let attendeeRef = db.eventDB.collection(vm.event_collectionName).doc("AttendeeList").collection("Attendees");
            attendeeRef.where("Email", "==", `${Email.toLowerCase()}`).get().then(function (snapShot) {
                if (snapShot.docs.length) {
                    let doc = snapShot.docs[0];
                    resolve(doc.data())
                }
                else {
                    resolve(null)
                }
            })
        })
    },
    CreateNotification: function (row) {
        console.log("11-------------");

        return new Promise((resolve) => {


            if (row["Group"] != "" && row["Group"].toString().length > 0) {
                debugger;
                var arrsplitgroup = [];
                arrsplitgroup = row["Group"].split("|");
                var arrLoccalgroup = [];
                if (arrsplitgroup.length > 0) {
                    for (var i = 0; i < arrsplitgroup.length; i++) {
                        console.log(" groupId :-" + arrsplitgroup[i]);

                        arrLoccalgroup.push({
                            GroupId: arrsplitgroup[i],
                        });
                    }
                }

                debugger;

                var scheduleDateStr = (row["Date"] == undefined ?
                    "" :
                    row["Date"]
                )
                    .toString()
                    .trim();

                scheduleDateStr = scheduleDateStr
                    .replace(" ", "T")
                    .replace("/", "-")
                    .replace("/", "-");
                //var endDateStr = row["End Date"] == undefined ? "" : row["End Date"];
                var scheduleDateSeconds = scheduleDateStr == "" ? 0 : Date.parse(scheduleDateStr);
                var scheduleDate = scheduleDateSeconds == 0 ? null : new Date(scheduleDateSeconds);






                var docObj = new Object();
                docObj.Groups = arrLoccalgroup;
                docObj.CreatedDate = new Date();
                docObj.LastModifiedDate = new Date();
                docObj.IsScheduled = row["IsScheduled"] == undefined ? false : row["IsScheduled"];
                docObj.NotificationTitle = row["NotificationTitle"] == undefined ? "" : row["NotificationTitle"];
                docObj.NotificationMessage = row["Message"] == undefined ? "" : row["Message"];
                docObj.scheduleDateTime = scheduleDate; //new Date();

                docObj.status = row["IsScheduled"].toString().toLowerCase() == "true" ? true : false;
                if (arrLoccalgroup.length > 0) {
                    var cRef = db.eventDB
                        .collection(vm.event_collectionName)
                        .doc("NotificationList")
                        .collection("Notifications");

                    cRef
                        .add(docObj)
                        .then(function (e) {
                            console.log(e);
                            console.log("success");

                            resolve('Notifications Created');
                            window.location.reload();
                            // this.$vs.notify({
                            //     color: "success",
                            //     position: "top-center",
                            //     title: "Round Table",
                            //     text: "Round Table updated successfully.",
                            // });
                        })
                        .catch((error) => {
                            console.log(error);
                            // this.$vs.notify({
                            //     color: "warning",
                            //     position: "top-center",
                            //     title: "Notification",
                            //     text: "Something went wrong!",
                            // });
                            //vm.popupActiveAddNotification = false;
                            // alert(error);
                        });



                }

            }
        });
    },
    GetDemoUserRoleByRoleId: function (roleId) {
        console.log("12-------------");
        //debugger;
        var docObj = Object();
        switch (roleId) {
            case 1:
                docObj = { RoleID: roleId, RoleName: "SuperAdmin" };
                break;
            case 2:
                docObj = { RoleID: roleId, RoleName: "ClientAdmin" };
                break;
            case 3:
                docObj = { RoleID: roleId, RoleName: "EventAdmin" };
                break;
            case 10:
                docObj = { RoleID: roleId, RoleName: "AppUser" };
                break;
            case 11:
                docObj = { RoleID: roleId, RoleName: "Speaker" };
                break;
            case 12:
                docObj = { RoleID: roleId, RoleName: "Exhibitor" };
                break;
            case 13:
                docObj = { RoleID: roleId, RoleName: "Sponsor" };
                break;
        }
        return docObj;
    },
    GetSessionTypeDetailsByTypeId: function (typeId, videoUrl, StartDateTime, VideoLengthMinutes, RoundTableTopic) {
        //debugger;
        //StartDateTime = new Date();
        console.log("13-------------");
        var docObj = Object();
        switch (typeId) {
            case 1:
                docObj = {
                    TypeID: 1,
                    TypeName: "On Demand",
                    VideoURL: videoUrl,
                    VideoLengthMinutes: VideoLengthMinutes
                };
                break;
            case 2:
                docObj = {
                    TypeID: 2,
                    TypeName: "Live Stream",
                    LiveStreamURL: videoUrl,
                    StartDateTime: StartDateTime,
                    StreamLengthMinutes: VideoLengthMinutes
                };
                break;
            case 3:
                docObj = { TypeID: 3, TypeName: "Live Panel" };
                break;
            case 4:
                docObj = {
                    TypeID: 4,
                    TypeName: "Round Table",
                    RoundTableTopic: {
                        TopicId: 0,
                        TopicName: RoundTableTopic
                    }
                };
                break;
            case 5:
                docObj = { TypeID: 5, TypeName: "In-Person" };
                break;
        }
        return docObj;
    },
    AddUserRole: function (roleId, row, autoId) {
        console.log("14-------------");
        return new Promise((resolve, reject) => {
            //debugger;
            var email = row["Email"].trim();
            this.getUserDetailbyEmail(email.toLowerCase())
                .then(querySnapshot => {
                    if (!querySnapshot) {
                        console.log("User does not exists. Email:" + email);
                        reject('user not exist')
                    } else {
                        var doc = querySnapshot;
                        autoId = doc.UserId;
                        //debugger;
                        var data = doc;
                        var userRoles = data.UserRoles;
                        var filteredRoles = userRoles.filter(function (value) {
                            return roleId == value.RoleID;
                        });
                        if (filteredRoles.length == 0) {
                            userRoles.push(vm.GetDemoUserRoleByRoleId(roleId));
                        }
                        this.updateUserbyId({ UserId: autoId, UserRoles: userRoles })
                            .then(function () {
                                //console.log("User Updated : ");
                                if (roleId == 10) {
                                    /*vm.CreateAttendeeAndUser(row, autoId, true).then(function() {
                                        resolve('attendee created')
                                    });*/
                                } else if (roleId == 11) {
                                    vm.CreateSpeaker(row, autoId, true).then(function () {
                                        resolve('speaker created')
                                    });
                                } else if (roleId == 12) {
                                    vm.CreateExhibitor(row, autoId).then(function () {
                                        resolve('exhibitor created')
                                    });
                                } else if (roleId == 13) {
                                    vm.CreateSponsor(row, autoId).then(function () {
                                        resolve('sponsor created')
                                    });
                                }
                            })
                            .catch(function (error) {
                                console.error("Error creating user: ", error);
                            });
                    }
                    //alert("User Created Successfully");
                    //resolve('user role added')
                })
                .catch(function (error) {
                    console.log("Error saving attendee:", error);
                });
        });
    },
    // generateNumber() {
    //     return new Promise((resolve, reject) => {
    //         let random = new Random(); // uses the nativeMath engine
    //         //const value = random.hex(numberLength);
    //         let value = random.integer(100000, 999999);
    //         resolve(value.toString())
    //     })
    // },
    CreateAttendeeAndUser: function (row, autoId, isUserExist) {
        console.log("15-------------");
        return new Promise((resolve, reject) => {
            debugger;
            var email = (row["Email"] == undefined ? "" : row["Email"]).trim();

            var attendeeTags = (row["Tags"] == undefined ? "" : row["Tags"]).trim();
            //Attendee
            var docObj = new Object();
            docObj.FirstName = (row["First Name"] == undefined ?
                "" :
                row["First Name"]
            ).trim();
            docObj.LastName = (row["Last Name"] == undefined ?
                "" :
                row["Last Name"]
            ).trim();
            docObj.Name = docObj.FirstName + " " + docObj.LastName;
            docObj.Email = (row["Email"] == undefined ? "" : row["Email"].toLowerCase()).trim();
            docObj.Tags = attendeeTags;
            docObj.Phone = (row["Phone"] == undefined ? "" : row["Phone"])
                .toString()
                .trim();
            docObj.Company = (row["Company"] == undefined ?
                "" :
                row["Company"]
            ).trim();
            docObj.Country = (row["Country"] == undefined ?
                "" :
                row["Country"]
            ).trim();
            docObj.Designation = (row["Title"] == undefined ?
                "" :
                row["Title"]
            ).trim();
            docObj.ProfilePictureURL = (row["Profile Picture URL"] == undefined ?
                "" :
                row["Profile Picture URL"]
            ).trim();
            docObj.Profile = (row["Profile"] == undefined ?
                "" :
                row["Profile"]
            ).trim();
            docObj.Website = (row["Website"] == undefined ?
                "" :
                row["Website"]
            ).trim();
            docObj.ProfilePictureURL = (row["Profile Picture URL"] == undefined ?
                "" :
                row["Profile Picture URL"]
            ).trim();
            docObj.SocialLinks = [{
                Facebook: (row["Facebook"] == undefined ? "" : row["Facebook"]).trim()
            },
            {
                Twitter: (row["Twitter"] == undefined ? "" : row["Twitter"]).trim()
            },
            {
                GooglePlus: (row["GooglePlus"] == undefined ?
                    "" :
                    row["GooglePlus"]
                ).trim()
            },
            {
                LinkedIn: (row["LinkedIn"] == undefined ? "" : row["LinkedIn"]).trim()
            }
            ];

            if (!isUserExist) {
                /*vm.CreateUserFirst(docObj, 10, row, autoId).then(function(res) {
                    resolve('User Created')
                }); */
                this.createAttendeeUserByAPI(docObj).then(function (res) {
                    console.log(res);
                    resolve('User & Attendee Created')
                }).catch(err => {
                    reject(err)
                })
            } else {
                db.eventDB
                    .collection(vm.event_collectionName)
                    .doc("AttendeeList")
                    .collection("Attendees")
                    .where("Email", "==", email.toLowerCase())
                    .get()
                    .then(querySnapshot => {
                        if (querySnapshot.docs.length == 0) {
                            docObj.AttendeeId = autoId; //"A" + new Date().getTime(); //row["Email"].trim(); //row["Attendee ID"];
                            docObj.MailSent = false;
                            docObj.IsVerified = true;
                            docObj.IsPublished = true;
                            docObj.UserRoles = [{
                                RoleID: 10,
                                RoleName: "AppUser"
                            }];
                            docObj.CreatedDate = new Date();
                            docObj.LastModifiedDate = new Date();
                            db.eventDB
                                .collection(vm.event_collectionName)
                                .doc("AttendeeList")
                                .collection("Attendees")
                                .doc(autoId)
                                .set(docObj)
                                .then(function () {
                                    vm.MapUserWithEvent(autoId).then(function () {
                                        vm.AddAttendeeTag(attendeeTags).then(function () {
                                            resolve('Attendee Created')
                                        });
                                    });


                                })
                                .catch(function (error) {
                                    console.error("Error creating attendee: ", error);
                                });
                        } else {
                            autoId = querySnapshot.docs[0].id;
                            docObj.LastModifiedDate = new Date();
                            db.eventDB
                                .collection(vm.event_collectionName)
                                .doc("AttendeeList")
                                .collection("Attendees")
                                .doc(autoId)
                                .update({
                                    FirstName: (row["First Name"] == undefined ?
                                        "" :
                                        row["First Name"]
                                    ).trim(),
                                    LastName: (row["Last Name"] == undefined ?
                                        "" :
                                        row["Last Name"]
                                    ).trim(),
                                    Name:
                                        (row["First Name"] == undefined ?
                                            "" :
                                            row["First Name"]
                                        ).trim() +
                                        " " +
                                        (row["Last Name"] == undefined ?
                                            "" :
                                            row["Last Name"]
                                        ).trim(),
                                    Tags: attendeeTags,
                                    Phone: (row["Phone"] == undefined ? "" : row["Phone"])
                                        .toString()
                                        .trim(),
                                    Company: (row["Company"] == undefined ?
                                        "" :
                                        row["Company"]
                                    ).trim(),
                                    Designation: (row["Title"] == undefined ?
                                        "" :
                                        row["Title"]
                                    ).trim(),
                                    Profile: (row["Profile"] == undefined ?
                                        "" :
                                        row["Profile"]
                                    ).trim(),
                                    ProfilePictureURL: (row["Profile Picture URL"] == undefined ?
                                        "" :
                                        row["Profile Picture URL"]
                                    ).trim(),
                                    Website: (row["Website"] == undefined ?
                                        "" :
                                        row["Website"]
                                    ).trim(),
                                    SocialLinks: [{
                                        Facebook: (row["Facebook"] == undefined ?
                                            "" :
                                            row["Facebook"]
                                        ).trim()
                                    },
                                    {
                                        Twitter: (row["Twitter"] == undefined ?
                                            "" :
                                            row["Twitter"]
                                        ).trim()
                                    },
                                    {
                                        GooglePlus: (row["GooglePlus"] == undefined ?
                                            "" :
                                            row["GooglePlus"]
                                        ).trim()
                                    },
                                    {
                                        LinkedIn: (row["LinkedIn"] == undefined ?
                                            "" :
                                            row["LinkedIn"]
                                        ).trim()
                                    }
                                    ],
                                    LastModifiedDate: new Date()
                                })
                                .then(function () {
                                    //vm.MapUserWithEvent(autoId);
                                    //vm.AddAttendeeTag(attendeeTags);
                                    //resolve("Attendee Updated");
                                    vm.MapUserWithEvent(autoId).then(function () {
                                        vm.AddAttendeeTag(attendeeTags).then(function () {
                                            resolve('Attendee Updated')
                                        });
                                    });
                                })
                                .catch(function (error) {
                                    console.error("Error creating attendee: ", error);
                                });
                        }
                    })
            }
        });
    },
    CreateSpeaker: function (row, autoId, isUserExist) {
        console.log("16-------------");
        return new Promise((resolve, reject) => {
            if (autoId == 0) {
                reject("autoId 0");
            }
            //var name = (row["Name"] == undefined ? "" : row["Name"]).trim();
            var email = (row["Email"] == undefined ? "" : row["Email"]).trim();

            if (!isUserExist) {
                vm.AddUserRole(11, row, isUserExist).then(function (res) {
                    console.log(res);
                    resolve('user role added')
                });
            } else {
                var docObj = new Object();

                let resourceFiles = (row["Resource File URL"] == undefined ?
                    "" :
                    row["Resource File URL"]
                )
                    .trim()
                    .split(",");

                if (Array.isArray(resourceFiles)) {
                    resourceFiles = resourceFiles.map(str => str.trim());
                }

                docObj.SpeakerId = autoId; //row["Email"].trim(); //row["Speaker Id"];
                docObj.FirstName = (row["First Name"] == undefined ?
                    "" :
                    row["First Name"]
                ).trim();
                docObj.LastName = (row["Last Name"] == undefined ?
                    "" :
                    row["Last Name"]
                ).trim();
                docObj.Name = docObj.FirstName + " " + docObj.LastName;
                docObj.Email = (row["Email"] == undefined ? "" : row["Email"].toLowerCase()).trim();
                docObj.Phone = (row["Phone"] == undefined ? "" : row["Phone"])
                    .toString()
                    .trim();
                docObj.Company = (row["Company"] == undefined ?
                    "" :
                    row["Company"]
                ).trim();
                docObj.Designation = (row["Title"] == undefined ?
                    "" :
                    row["Title"]
                ).trim();
                docObj.ProfilePictureURL = (row["Profile Picture URL"] == undefined ?
                    "" :
                    row["Profile Picture URL"]
                ).trim();
                docObj.Resources = resourceFiles;
                docObj.Group = (row["Group"] == undefined ? "" : row["Group"]).trim();
                docObj.Website = (row["Website"] == undefined ?
                    "" :
                    row["Website"]
                ).trim();
                docObj.Profile = (row["Profile"] == undefined ?
                    "" :
                    row["Profile"]
                ).trim();
                docObj.SocialLinks = [{
                    Facebook: (row["Facebook"] == undefined ?
                        "" :
                        row["Facebook"]
                    ).trim()
                },
                {
                    Twitter: (row["Twitter"] == undefined ? "" : row["Twitter"]).trim()
                },
                {
                    GooglePlus: (row["GooglePlus"] == undefined ?
                        "" :
                        row["GooglePlus"]
                    ).trim()
                },
                {
                    LinkedIn: (row["LinkedIn"] == undefined ?
                        "" :
                        row["LinkedIn"]
                    ).trim()
                }
                ];

                db.eventDB
                    .collection(vm.event_collectionName)
                    .doc("SpeakerList")
                    .collection("Speakers")
                    .where("Email", "==", email.toLowerCase())
                    .get()
                    .then(querySnapshot => {
                        if (querySnapshot.docs.length == 0) {
                            //docObj.AutoId = vm.GenerateAutoId("speaker");
                            docObj.UserRoles = [{
                                RoleID: 10,
                                RoleName: "AppUser"
                            },
                            {
                                RoleID: 11,
                                RoleName: "Speaker"
                            }
                            ];
                            docObj.IsPublished = true;
                            docObj.CreatedDate = new Date();
                            docObj.LastModifiedDate = new Date();
                            debugger;
                            db.eventDB
                                .collection(vm.event_collectionName)
                                .doc("SpeakerList")
                                .collection("Speakers")
                                .doc(autoId)
                                .set(docObj)
                                .then(function () {
                                    vm.MapUserWithEvent().then(function () {
                                        resolve("Speaker Created : " + docObj.Email);
                                    });
                                })
                                .catch(function (error) {
                                    console.error("Error creating speaker: ", error);
                                });
                        } else {
                            //console.log('exist- '+docObj.Email);
                            docObj.LastModifiedDate = new Date();
                            db.eventDB
                                .collection(vm.event_collectionName)
                                .doc("SpeakerList")
                                .collection("Speakers")
                                .doc(autoId)
                                .update({
                                    FirstName: (row["First Name"] == undefined ?
                                        "" :
                                        row["First Name"]
                                    ).trim(),
                                    LastName: (row["Last Name"] == undefined ?
                                        "" :
                                        row["Last Name"]
                                    ).trim(),
                                    Name:
                                        (row["First Name"] == undefined ?
                                            "" :
                                            row["First Name"]
                                        ).trim() +
                                        " " +
                                        (row["Last Name"] == undefined ?
                                            "" :
                                            row["Last Name"]
                                        ).trim(),
                                    Phone: (row["Phone"] == undefined ? "" : row["Phone"])
                                        .toString()
                                        .trim(),
                                    Company: (row["Company"] == undefined ?
                                        "" :
                                        row["Company"]
                                    ).trim(),
                                    Designation: (row["Title"] == undefined ?
                                        "" :
                                        row["Title"]
                                    ).trim(),
                                    Profile: (row["Profile"] == undefined ?
                                        "" :
                                        row["Profile"]
                                    ).trim(),
                                    ProfilePictureURL: (row["Profile Picture URL"] == undefined ?
                                        "" :
                                        row["Profile Picture URL"]
                                    ).trim(),
                                    Resources: resourceFiles,
                                    Group: (row["Group"] == undefined ? "" : row["Group"]).trim(),
                                    Website: (row["Website"] == undefined ?
                                        "" :
                                        row["Website"]
                                    ).trim(),
                                    SocialLinks: [{
                                        Facebook: (row["Facebook"] == undefined ?
                                            "" :
                                            row["Facebook"]
                                        ).trim()
                                    },
                                    {
                                        Twitter: (row["Twitter"] == undefined ?
                                            "" :
                                            row["Twitter"]
                                        ).trim()
                                    },
                                    {
                                        GooglePlus: (row["GooglePlus"] == undefined ?
                                            "" :
                                            row["GooglePlus"]
                                        ).trim()
                                    },
                                    {
                                        LinkedIn: (row["LinkedIn"] == undefined ?
                                            "" :
                                            row["LinkedIn"]
                                        ).trim()
                                    }
                                    ],
                                    LastModifiedDate: new Date()
                                })
                                .then(function () {
                                    resolve("Speaker Updated : " + docObj.Email);
                                })
                                .catch(function (error) {
                                    console.error("Error creating speaker: ", error);
                                });
                        }
                        //alert("Speaker Created Successfully");
                    })
                    .catch(function (error) {
                        console.log("Error saving speaker:", error);
                    });
            }
        });
    },
    CreateSponsor: function (row, autoId) {
        console.log("17-------------");
        //isUserExist
        return new Promise((resolve, reject) => {
            debugger;
            if (autoId == 0) {
                reject('autoId cannot be 0')
            }
            //var email =  (row["Email"] == undefined ? "" : row["Email"]).trim();
            var name = (row["Name"] == undefined ? "" : row["Name"]).trim();

            let showcaseImages = (row["Showcase Images"] == undefined ?
                "" :
                row["Showcase Images"]
            )
                .trim()
                .split(",");
            showcaseImages = showcaseImages.map(str => str.trim());

            let resourceFiles = (row["Resource File URL"] == undefined ?
                "" :
                row["Resource File URL"]
            )
                .trim()
                .split(",");

            if (Array.isArray(resourceFiles)) {
                resourceFiles = resourceFiles.map(str => str.trim());
            }

            let MappedContactsArr = [];
            let MappedContactsArrTrimmed = [];
            if (row["Mapped Attendees"]) {
                MappedContactsArr = row["Mapped Attendees"].split(",");
                MappedContactsArrTrimmed = MappedContactsArr.map(str => str.trim());
            }
            let MappedContacts = [];

            var docObj = new Object();
            docObj.SponsorId = autoId; //row["Email"].trim(); //row["Exhibitor Id"];
            docObj.Name = name;
            docObj.Category = (row["Category"] == undefined ?
                { CategoryPriority: 0 } :
                row["Category"]
            ).trim();
            docObj.BoothNo = (row["Booth No"] == undefined ? "" : row["Booth No"])
                .toString()
                .trim();
            docObj.Logo = (row["Logo"] == undefined ? "" : row["Logo"]).trim();
            docObj.ShowcaseImages = showcaseImages;
            docObj.Resources = resourceFiles;
            docObj.Email = (row["Email"] == undefined ? "" : row["Email"]).trim();
            docObj.Phone = (row["Phone"] == undefined ? "" : row["Phone"])
                .toString()
                .trim();
            docObj.Website = (row["Website"] == undefined ?
                "" :
                row["Website"]
            ).trim();
            docObj.Profile = (row["Profile"] == undefined ?
                "" :
                row["Profile"]
            ).trim();
            docObj.HotspotImageURL = (row["Hotspot Image URL"] == undefined ?
                "" :
                row["Hotspot Image URL"]
            ).trim();
            docObj.ShowcaseVideoURL = (row["Showcase Video URL"] == undefined ?
                "" :
                row["Showcase Video URL"]
            ).trim();
            docObj.SocialLinks = [{
                Facebook: (row["Facebook"] == undefined ? "" : row["Facebook"]).trim()
            },
            {
                Twitter: (row["Twitter"] == undefined ? "" : row["Twitter"]).trim()
            },
            {
                GooglePlus: (row["GooglePlus"] == undefined ?
                    "" :
                    row["GooglePlus"]
                ).trim()
            },
            {
                LinkedIn: (row["LinkedIn"] == undefined ? "" : row["LinkedIn"]).trim()
            }
            ];

            for (let i = 0; i < MappedContactsArrTrimmed.length; i++) {
                if (MappedContactsArrTrimmed[i] != "") {
                    var attendee = attendeeList.filter(function (value) {
                        return value.data().Email.toLowerCase() == MappedContactsArrTrimmed[i];
                    });
                    if (attendee.length > 0) {
                        attendee = attendee[0];
                        var d = attendee.data();
                        MappedContacts.push({
                            //id: attendee.id,
                            AttendeeId: d.AttendeeId,
                            FirstName: d.FirstName,
                            LastName: d.LastName,
                            Name: d.FirstName + " " + d.LastName,
                            Company: d.Company,
                            Designation: d.Designation,
                            ProfilePictureURL: d.ProfilePictureURL,
                            Phone: d.Phone,
                            Email: d.Email.toLowerCase()
                        });
                    }
                }
            }
            docObj.MappedContacts = MappedContacts;

            db.eventDB
                .collection(vm.event_collectionName)
                .doc("SponsorList")
                .collection("Sponsors")
                //.where("Email", "==", email)
                .where("Name", "==", name)
                .get()
                .then(querySnapshot => {
                    if (querySnapshot.docs.length == 0) {
                        //docObj.AutoId = vm.GenerateAutoId("sponsor");
                        docObj.UserRoles = [{
                            RoleID: 10,
                            RoleName: "AppUser"
                        },
                        {
                            RoleID: 13,
                            RoleName: "Sponsor"
                        }
                        ];
                        docObj.CreatedDate = new Date();
                        docObj.LastModifiedDate = new Date();
                        db.eventDB
                            .collection(vm.event_collectionName)
                            .doc("SponsorList")
                            .collection("Sponsors")
                            .doc(autoId)
                            .set(docObj)
                            .then(function () {
                                resolve("Sponsor Created : " + docObj.Email);
                            })
                            .catch(function (error) {
                                console.error("Error creating Sponsor: ", error);
                            });
                    } else {
                        autoId = querySnapshot.docs[0].id
                        docObj.LastModifiedDate = new Date();
                        db.eventDB
                            .collection(vm.event_collectionName)
                            .doc("SponsorList")
                            .collection("Sponsors")
                            .doc(autoId)
                            .update({
                                Name: name,
                                Category: (row["Category"] == undefined ?
                                    "" :
                                    row["Category"]
                                ).trim(),
                                BoothNo: (row["Booth No"] == undefined ? "" : row["Booth No"])
                                    .toString()
                                    .trim(),
                                Logo: (row["Logo"] == undefined ? "" : row["Logo"]).trim(),
                                ShowcaseImages: showcaseImages,
                                Resources: resourceFiles,
                                //Email: (row["Email"] == undefined ? "" : row["Email"]).trim(),
                                Phone: (row["Phone"] == undefined ? "" : row["Phone"])
                                    .toString()
                                    .trim(),
                                Website: (row["Website"] == undefined ?
                                    "" :
                                    row["Website"]
                                ).trim(),
                                Profile: (row["Profile"] == undefined ?
                                    "" :
                                    row["Profile"]
                                ).trim(),
                                HotspotImageURL: (row["HotspotImageURL"] == undefined ?
                                    "" :
                                    row["HotspotImageURL"]
                                ).trim(),
                                ShowcaseVideoURL: (row["ShowcaseVideoURL"] == undefined ?
                                    "" :
                                    row["ShowcaseVideoURL"]
                                ).trim(),
                                SocialLinks: [{
                                    Facebook: (row["Facebook"] == undefined ?
                                        "" :
                                        row["Facebook"]
                                    ).trim()
                                },
                                {
                                    Twitter: (row["Twitter"] == undefined ?
                                        "" :
                                        row["Twitter"]
                                    ).trim()
                                },
                                {
                                    GooglePlus: (row["GooglePlus"] == undefined ?
                                        "" :
                                        row["GooglePlus"]
                                    ).trim()
                                },
                                {
                                    LinkedIn: (row["LinkedIn"] == undefined ?
                                        "" :
                                        row["LinkedIn"]
                                    ).trim()
                                }
                                ],
                                MappedContacts: MappedContacts
                            })
                            .then(function () {
                                resolve("Sponsor Updated : " + docObj.Email);
                            })
                            .catch(function (error) {
                                console.error("Error creating Sponsor: ", error);
                            });
                    }
                    //alert("Sponsor Created Successfully");
                })
                .catch(function (error) {
                    console.log("Error saving Sponsor:", error);
                });
            //}

        })
    },
    CreateExhibitor: function (row, autoId) {
        console.log("18-------------");
        return new Promise((resolve, reject) => {
            debugger;
            if (autoId == 0) {
                reject('autoId 0');
            }
            //var email =  (row["Email"] == undefined ? "" : row["Email"]).trim();
            var name = (row["Name"] == undefined ? "" : row["Name"]).trim();

            let showcaseImages = (row["Showcase Images"] == undefined ?
                "" :
                row["Showcase Images"]
            )
                .trim()
                .split(",");
            showcaseImages = showcaseImages.map(str => str.trim());

            let resourceFiles = (row["Resource File URL"] == undefined ?
                "" :
                row["Resource File URL"]
            )
                .trim()
                .split(",");

            if (Array.isArray(resourceFiles)) {
                resourceFiles = resourceFiles.map(str => str.trim());
            }

            let MappedContactsArr = [];
            let MappedContactsArrTrimmed = [];
            if (row["Mapped Attendees"]) {
                MappedContactsArr = row["Mapped Attendees"].split(",");
                MappedContactsArrTrimmed = MappedContactsArr.map(str => str.trim());
            }
            let MappedContacts = [];

            var docObj = new Object();
            docObj.ExhibitorId = autoId; //row["Email"].trim(); //row["Exhibitor Id"];
            docObj.Name = name;
            docObj.Category = (row["Category"] == undefined ?
                { CategoryPriority: 0 } :
                row["Category"]
            ).trim();
            docObj.BoothNo = (row["Booth No"] == undefined ? "" : row["Booth No"])
                .toString()
                .trim();
            docObj.Logo = (row["Logo"] == undefined ? "" : row["Logo"]).trim();
            docObj.ShowcaseImages = showcaseImages;
            docObj.Resources = resourceFiles;
            docObj.Email = (row["Email"] == undefined ? "" : row["Email"]).trim();
            docObj.Phone = (row["Phone"] == undefined ? "" : row["Phone"])
                .toString()
                .trim();
            docObj.Website = (row["Website"] == undefined ?
                "" :
                row["Website"]
            ).trim();
            docObj.Profile = (row["Profile"] == undefined ?
                "" :
                row["Profile"]
            ).trim();
            docObj.HotspotImageURL = (row["Hotspot Image URL"] == undefined ?
                "" :
                row["Hotspot Image URL"]
            ).trim();
            docObj.ShowcaseVideoURL = (row["Showcase Video URL"] == undefined ?
                "" :
                row["Showcase Video URL"]
            ).trim();
            docObj.SocialLinks = [{
                Facebook: (row["Facebook"] == undefined ? "" : row["Facebook"]).trim()
            },
            {
                Twitter: (row["Twitter"] == undefined ? "" : row["Twitter"]).trim()
            },
            {
                GooglePlus: (row["GooglePlus"] == undefined ?
                    "" :
                    row["GooglePlus"]
                ).trim()
            },
            {
                LinkedIn: (row["LinkedIn"] == undefined ? "" : row["LinkedIn"]).trim()
            }
            ];

            for (let i = 0; i < MappedContactsArrTrimmed.length; i++) {
                if (MappedContactsArrTrimmed[i] != "") {
                    var attendee = attendeeList.filter(function (value) {
                        return value.data().Email.toLowerCase() == MappedContactsArrTrimmed[i];
                    });
                    if (attendee.length > 0) {
                        attendee = attendee[0];
                        var d = attendee.data();
                        MappedContacts.push({
                            //id: attendee.id,
                            AttendeeId: d.AttendeeId,
                            FirstName: d.FirstName,
                            LastName: d.LastName,
                            Name: d.FirstName + " " + d.LastName,
                            Company: d.Company,
                            Designation: d.Designation,
                            ProfilePictureURL: d.ProfilePictureURL ? d.ProfilePictureURL : "",
                            Phone: d.Phone,
                            Email: d.Email.toLowerCase()
                        });
                    }
                }
            }
            docObj.MappedContacts = MappedContacts;

            db.eventDB
                .collection(vm.event_collectionName)
                .doc("ExhibitorList")
                .collection("Exhibitors")
                //.where("Email", "==", email)
                .where("Name", "==", name)
                .get()
                .then(querySnapshot => {
                    if (querySnapshot.docs.length == 0) {
                        //docObj.AutoId = vm.GenerateAutoId("exhibitor");
                        docObj.UserRoles = [{
                            RoleID: 10,
                            RoleName: "AppUser"
                        },
                        {
                            RoleID: 12,
                            RoleName: "Exhibitor"
                        }
                        ];
                        docObj.CreatedDate = new Date();
                        docObj.LastModifiedDate = new Date();
                        db.eventDB
                            .collection(vm.event_collectionName)
                            .doc("ExhibitorList")
                            .collection("Exhibitors")
                            .doc(autoId)
                            .set(docObj)
                            .then(function () {
                                resolve("Exhibitor Created : " + docObj.Email);
                            })
                            .catch(function (error) {
                                console.error("Error creating Exhibitor: ", error);
                            });
                    } else {
                        autoId = querySnapshot.docs[0].id;
                        docObj.LastModifiedDate = new Date();
                        db.eventDB
                            .collection(vm.event_collectionName)
                            .doc("ExhibitorList")
                            .collection("Exhibitors")
                            .doc(autoId)
                            .update({
                                Name: name,
                                Category: (row["Category"] == undefined ?
                                    "" :
                                    row["Category"]
                                ).trim(),
                                BoothNo: (row["Booth No"] == undefined ? "" : row["Booth No"])
                                    .toString()
                                    .trim(),
                                Logo: (row["Logo"] == undefined ? "" : row["Logo"]).trim(),
                                ShowcaseImages: showcaseImages,
                                Resources: resourceFiles,
                                //Email: (row["Email"] == undefined ? "" : row["Email"]).trim(),
                                Phone: (row["Phone"] == undefined ? "" : row["Phone"])
                                    .toString()
                                    .trim(),
                                Website: (row["Website"] == undefined ?
                                    "" :
                                    row["Website"]
                                ).trim(),
                                Profile: (row["Profile"] == undefined ?
                                    "" :
                                    row["Profile"]
                                ).trim(),
                                HotspotImageURL: (row["HotspotImageURL"] == undefined ?
                                    "" :
                                    row["HotspotImageURL"]
                                ).trim(),
                                ShowcaseVideoURL: (row["ShowcaseVideoURL"] == undefined ?
                                    "" :
                                    row["ShowcaseVideoURL"]
                                ).trim(),
                                SocialLinks: [{
                                    Facebook: (row["Facebook"] == undefined ?
                                        "" :
                                        row["Facebook"]
                                    ).trim()
                                },
                                {
                                    Twitter: (row["Twitter"] == undefined ?
                                        "" :
                                        row["Twitter"]
                                    ).trim()
                                },
                                {
                                    GooglePlus: (row["GooglePlus"] == undefined ?
                                        "" :
                                        row["GooglePlus"]
                                    ).trim()
                                },
                                {
                                    LinkedIn: (row["LinkedIn"] == undefined ?
                                        "" :
                                        row["LinkedIn"]
                                    ).trim()
                                }
                                ],
                                MappedContacts: MappedContacts
                            })
                            .then(function () {
                                resolve("Exhibitor Updated : " + docObj.Email);
                            })
                            .catch(function (error) {
                                console.error("Error creating Exhibitor: ", error);
                            });
                    }
                    //alert("Exhibitor Created Successfully");
                })
                .catch(function (error) {
                    console.log("Error saving Exhibitor:", error);
                });
        });
    },
    CreateRoundTable: function (row, autoId) {
        console.log("19-------------");
        return new Promise((resolve) => {
            let host = [];
            let mappedAttendees = [];

            /*var topicName = (row["Topic Name"] == undefined ?
                "" :
                row["Topic Name"]
            ).trim();*/

            let topicName = "General"
            let topicTableCapacity = generalRTCapacity;

            if (row["Group Name"]) {
                topicName = row["Group Name"].trim()
                topicTableCapacity = maxRTCapacity
            }

            let topic = new Object();
            topic.TopicId = 0;
            topic.TopicName = topicName;
            topic.TopicTableCapacity = topicTableCapacity;

            for (let i = 0; i < roundTableTopicList.length; i++) {
                var rTopic = roundTableTopicList[i].data();
                let ttopicname = topicName ? topicName.toLowerCase() : null
                let rtopicname = rTopic.TopicName ? rTopic.TopicName.toLowerCase() : null
                if (ttopicname && rtopicname && ttopicname == rtopicname) {
                    topic.TopicId = rTopic.TopicId;
                    topic.TopicName = rTopic.TopicName;
                    topic.TopicTableCapacity = rTopic.TableCapacity ? rTopic.TableCapacity : topic.TopicTableCapacity;
                    break;
                }
            }

            let mappedContactsArr = [];
            let mappedContactsArrTrimmed = [];
            if (row["Mapped Attendees"]) {
                mappedContactsArr = row["Mapped Attendees"].split(",");
                mappedContactsArrTrimmed = mappedContactsArr.map(str => str.trim());
            }
            for (let i = 0; i < mappedContactsArrTrimmed.length; i++) {
                if (mappedContactsArrTrimmed[i] != "") {
                    var attendee = attendeeList.filter(function (value) {
                        if (value.data().Email && value.data().Email.toLowerCase() == mappedContactsArrTrimmed[i])
                            return true
                        else
                            return false
                    });
                    if (attendee.length > 0) {
                        attendee = attendee[0];
                        var d = attendee.data();
                        mappedAttendees.push({
                            //id: attendee.id,
                            AttendeeId: d.AttendeeId,
                            FirstName: d.FirstName,
                            LastName: d.LastName,
                            Name: d.FirstName + " " + d.LastName,
                            Company: d.Company,
                            Designation: d.Designation,
                            ProfilePictureURL: d.ProfilePictureURL,
                            Phone: d.Phone,
                            Email: d.Email.toLowerCase()
                        });
                    }
                }
            }

            let mappedHostArr = [];
            let mappedHostArrTrimmed = [];
            if (row["Host"]) {
                mappedHostArr = row["Host"].split(",");
                mappedHostArrTrimmed = mappedHostArr.map(str => str.trim());
            }
            for (let i = 0; i < mappedHostArrTrimmed.length; i++) {
                if (mappedHostArrTrimmed[i] != "") {
                    attendee = attendeeList.filter(function (value) {
                        if (value.data().Email && value.data().Email.toLowerCase() == mappedHostArrTrimmed[i])
                            return true
                        else
                            return false
                    });
                    if (attendee.length > 0) {
                        attendee = attendee[0];
                        d = attendee.data();
                        host.push({
                            //id: attendee.id,
                            AttendeeId: d.AttendeeId,
                            FirstName: d.FirstName,
                            LastName: d.LastName,
                            Name: d.FirstName + " " + d.LastName,
                            Company: d.Company,
                            Designation: d.Designation,
                            ProfilePictureURL: d.ProfilePictureURL,
                            Phone: d.Phone,
                            Email: d.Email.toLowerCase()
                        });
                    }
                }
            }

            var docObj = new Object();
            docObj.TableId = String(row["Table ID"] == undefined ?
                "" :
                row["Table ID"]
            ).trim();
            if (docObj.TableId == "") {
                docObj.TableId = autoId;
            }
            docObj.TableName = (row["Table Name"] == undefined ?
                "" :
                row["Table Name"]
            ).trim();
            docObj.Capacity = topic.TopicTableCapacity; //row["Capacity"];
            docObj.Occupied = 0;
            docObj.Host = host;
            docObj.PreAssigned =
                (row["Pre-Assigned"] == undefined ?
                    "" :
                    row["Pre-Assigned"].toString().trim()) == "1" ?
                    true :
                    false;
            docObj.MappedAttendees = mappedAttendees;
            docObj.SpectatorEnabled =
                (row["Spectator Mode"] == undefined ?
                    "" :
                    row["Spectator Mode"].toString().trim()) == "1" ?
                    true :
                    false;
            docObj.CreatedByName = "";
            docObj.CreatedByID = "";
            docObj.ModifiedByName = "";
            docObj.ModifiedByID = "";

            docObj.Topic = topic;
            //docObj.TopicName = row["Topic Name"];
            //docObj.TypeId = "";
            //docObj.TypeName = row["Type Name"];

            //docObj.HostId = "";
            //docObj.HostName = "";
            //docObj.HostProfilePictureURL = row["HostProfilePictureURL"];

            if (docObj.TableId == "") {
                docObj.TableId = autoId; //"R" + new Date().getTime();
            }


            vm.createTopicIfNotExist(topic).then(function (topicObj) {
                if (topicObj) {
                    topicObj.TopicDisplayName = topicObj.TopicName && topicObj.TopicTableCapacity ? `${topicObj.TopicName} (${topicObj.TopicTableCapacity})` : topicObj.TopicName;
                    docObj.Topic = topicObj;
                    db.eventDB
                        .collection(vm.event_collectionName)
                        .doc("RoundTableList")
                        .collection("RoundTables")
                        .doc(docObj.TableId)
                        .get()
                        .then(function (doc) {
                            if (!doc.exists) {
                                //console.log('not exist- '+docObj.Email);
                                //docObj.AutoId = vm.GenerateAutoId("roundtable");
                                docObj.CreatedDate = new Date();
                                docObj.LastModifiedDate = new Date();
                                docObj.IsPublished = true;
                                db.eventDB
                                    .collection(vm.event_collectionName)
                                    .doc("RoundTableList")
                                    .collection("RoundTables")
                                    .doc(docObj.TableId)
                                    .set(docObj)
                                    .then(function () {
                                        if (docObj.Host.length) {
                                            docObj.Host.forEach(singleHost => {
                                                db.eventDB
                                                    .collection(vm.event_collectionName)
                                                    .doc("RoundTableList")
                                                    .collection("RoundTables")
                                                    .doc(docObj.TableId)
                                                    .collection("Participances")
                                                    .doc(singleHost.AttendeeId)
                                                    .get()
                                                    .then(function (docHost) {
                                                        debugger;
                                                        if (!docHost.exists) {
                                                            //console.log('not exist- '+docObj.Email);
                                                            var hostObj = new Object();
                                                            //hostObj.AutoId = vm.GenerateAutoId("roundtablehost");
                                                            hostObj.AttendeeId = singleHost.AttendeeId;
                                                            hostObj.IsActive = false;
                                                            hostObj.JoinTime = new Date();
                                                            hostObj.LeaveTime = null;
                                                            hostObj.Name = singleHost.Name;
                                                            hostObj.Company = singleHost.Company;
                                                            hostObj.Designation = singleHost.Designation;
                                                            hostObj.Email = singleHost.Email.toLowerCase();
                                                            hostObj.Phone = singleHost.Phone;
                                                            hostObj.ProfilePictureURL =
                                                                singleHost.ProfilePictureURL;
                                                            hostObj.UserAgent = navigator.userAgent;
                                                            hostObj.TableId = docObj.TableId;

                                                            hostObj.CreatedDate = new Date();
                                                            hostObj.LastModifiedDate = new Date();
                                                            db.eventDB
                                                                .collection(vm.event_collectionName)
                                                                .doc("RoundTableList")
                                                                .collection("RoundTables")
                                                                .doc(docObj.TableId)
                                                                .collection("Participances")
                                                                .doc(hostObj.AttendeeId)
                                                                .set(hostObj)
                                                                .then(function () {
                                                                    resolve("RoundTables Created : " + docObj.TableId);
                                                                    console.log(
                                                                        "RoundTable Host Created : " + hostObj.AttendeeId
                                                                    );
                                                                })
                                                                .catch(function (error) {
                                                                    console.error(
                                                                        "Error creating RoundTable Host: ",
                                                                        error
                                                                    );
                                                                });
                                                        } else {
                                                            resolve("RoundTables Created : " + docObj.TableId);
                                                            //console.log('exist- '+docObj.Email);
                                                        }
                                                        //alert("RoundTables Created Successfully");
                                                    })
                                                    .catch(function (error) {
                                                        console.log("Error saving RoundTables:", error);
                                                    });
                                            });
                                        }
                                        else {
                                            resolve("RoundTables Created : " + docObj.TableId);
                                        }
                                    })
                                    .catch(function (error) {
                                        console.error("Error creating RoundTables: ", error);
                                    });
                            } else {
                                //console.log('exist- '+docObj.Email);
                                topic.TopicDisplayName = topic.TopicName && topic.TopicTableCapacity ? `${topic.TopicName} (${topic.TopicTableCapacity})` : topic.TopicName;
                                docObj.LastModifiedDate = new Date();
                                db.eventDB.collection(vm.event_collectionName)
                                    .doc("RoundTableList")
                                    .collection("RoundTables")
                                    .doc(docObj.TableId)
                                    .update({
                                        TableName: docObj.TableName,
                                        Capacity: docObj.Capacity,
                                        PreAssigned: docObj.PreAssigned,
                                        MappedAttendees: mappedAttendees,
                                        Host: host,
                                        SpectatorEnabled: docObj.SpectatorEnabled,
                                        Topic: topic,
                                        LastModifiedDate: new Date()
                                    })
                                    .then(function () {
                                        console.log("RoundTables Updated : " + docObj.TableId);
                                        resolve("RoundTables Updated : " + docObj.TableId);
                                    })
                                    .catch(function (error) {
                                        console.error("Error creating RoundTables: ", error);
                                    });
                            }
                            //alert("RoundTables Created Successfully");
                        })
                }
                else {
                    vm.vs.notify({
                        color: "warning",
                        position: "top-center",
                        fixed: true,
                        title: "Table not created",
                        text: "Topic not Exists in table: " + docObj.TableName
                    })
                    resolve("RoundTables Topic not Exists : " + docObj.TableId);
                }
            })

        });
    },
    createTopicIfNotExist: function (topicObj) {
        console.log("20-------------");
        return new Promise((resolve) => {
            if (topicObj.TopicId) {
                resolve(topicObj)
            } else {
                resolve(null)
                /*let AutoID = "RTT" + new Date().getTime();
                let docObj = {
                    CreatedBy: '',
                    CreatedDate: new Date(),
                    TopicId: AutoID,
                    TopicName: topicObj.TopicName ? topicObj.TopicName : 'General',
                    TopicTableCapacity: topicObj.TopicTableCapacity,
                    IsPrivate: true,
                    LastModifiedDate: new Date()
                };
                db.eventDB
                    .collection(vm.event_collectionName)
                    .doc("RoundTableTopicList")
                    .collection("RoundTableTopics")
                    .doc(`${AutoID}`)
                    .set(docObj)
                    .then(function() {
                        resolve(docObj)
                    })*/
            }

        })
    },
    CreateSession: function (row, autoId) {
        console.log("21-------------");
        return new Promise((resolve) => {
            let ResourceFiles = row["Resource File URL"];
            ResourceFiles = (ResourceFiles == undefined ? "" : ResourceFiles)
                .toString()
                .trim();
            if (ResourceFiles != "") {
                ResourceFiles = ResourceFiles.split(",");
                ResourceFiles = ResourceFiles.map(str => str.trim());
            }

            let MappedContactsArr = [];
            let MappedContactsArrTrimmed = [];
            if (row["Mapped Speakers"]) {
                MappedContactsArr = row["Mapped Speakers"].split(",");
                MappedContactsArrTrimmed = MappedContactsArr.map(str => str.trim());
            }
            let MappedSpeakers = [];

            let MappedHostsArr = [];
            let MappedHostsArrTrimmed = [];
            var mappedHosts = row["Mapped Hosts"];
            mappedHosts = (mappedHosts == undefined ? "" : mappedHosts)
                .toString()
                .trim();
            if (mappedHosts) {
                MappedHostsArr = mappedHosts.split(",");
                MappedHostsArrTrimmed = MappedHostsArr.map(str => str.trim());
            }
            let MappedHosts = [];

            var docObj = new Object();

            docObj.SessionId = (row["Session ID"] == undefined ?
                "" :
                row["Session ID"]
            )
                .toString()
                .trim();
            docObj.Name = (row["Session Name"] == undefined ?
                "" :
                row["Session Name"]
            )
                .toString()
                .trim();
            debugger;
            var sessionStatus = (row["Status"] == undefined ? "" : row["Status"])
                .toString()
                .trim();
            var sessionStatusList = ["Ongoing", "Upcoming", "Finished"];
            sessionStatus = sessionStatusList.includes(sessionStatus) ?
                sessionStatus :
                "Upcoming";
            docObj.Status = sessionStatus;

            //alert(docObj.Name);
            var trackName = (row["Track Name"] == undefined ? "" : row["Track Name"])
                .toString()
                .trim();
            docObj.Track = {
                TrackID: "0",
                TrackName: trackName
            };
            debugger;
            for (let i = 0; i < sessionTrackList.length; i++) {
                var sTrack = sessionTrackList[i].data();
                if (trackName == sTrack.Name) {
                    //docObj.TrackID = sTrack.TrackID;
                    //docObj.TrackName = sTrack.TrackName;
                    docObj.Track = {
                        TrackID: sTrack.TrackId,
                        TrackName: sTrack.Name
                    };
                    break;
                }
            }

            var location = (row["Location"] == undefined ? "" : row["Location"])
                .toString()
                .trim();
            docObj.Location = { LocationID: "0", LocationName: location };

            for (let i = 0; i < sessionLocationList.length; i++) {
                var sLocation = sessionLocationList[i].data();
                if (location == sLocation.LocationName) {
                    //docObj.LocationID = sLocation.LocationID;
                    //docObj.LocationName = sLocation.LocationName;
                    docObj.Location = {
                        LocationID: sLocation.LocationID,
                        LocationName: sLocation.LocationName
                    };
                    break;
                }
            }

            var startDateStr = (row["Start Date"] == undefined ?
                "" :
                row["Start Date"]
            )
                .toString()
                .trim();

            startDateStr = startDateStr
                .replace(" ", "T")
                .replace("/", "-")
                .replace("/", "-");
            //var endDateStr = row["End Date"] == undefined ? "" : row["End Date"];
            var startDateSeconds = startDateStr == "" ? 0 : Date.parse(startDateStr);
            var startDate = startDateSeconds == 0 ? null : new Date(startDateSeconds);

            var endDateStr = (row["End Date"] == undefined ? "" : row["End Date"])
                .toString()
                .trim();
            endDateStr = endDateStr
                .replace(" ", "T")
                .replace("/", "-")
                .replace("/", "-");
            var endDateSeconds = endDateStr == "" ? 0 : Date.parse(endDateStr);
            var endDate = endDateSeconds == 0 ? null : new Date(endDateSeconds);

            docObj.StartDate = startDate; //new Date();
            docObj.EndDate = endDate; //new Date();
            docObj.Resources = ResourceFiles;
            docObj.SessionSettings = {
                PreRollImageURL: (row["Pre Role Image URL"] == undefined ?
                    "" :
                    row["Pre Role Image URL"]
                )
                    .toString()
                    .trim(),
                PostRollImageURL: (row["Post Role Image URL"] == undefined ?
                    "" :
                    row["Post Role Image URL"]
                )
                    .toString()
                    .trim()
            };
            var sessionTypeId =
                row["Session Type"] == undefined ? 0 : row["Session Type"];
            var videoURL = (row["Video URL"] == undefined ? "" : row["Video URL"])
                .toString()
                .trim();

            var liveStartDateStr = (row["Video Start Date Time"] == undefined ?
                "" :
                row["Video Start Date Time"]
            )
                .toString()
                .trim();
            liveStartDateStr = liveStartDateStr
                .replace(" ", "T")
                .replace("/", "-")
                .replace("/", "-");
            var liveStartDateSeconds =
                liveStartDateStr == "" ? 0 : Date.parse(liveStartDateStr);
            var liveStartDate =
                liveStartDateSeconds == 0 ? null : new Date(liveStartDateSeconds);

            var videoLengthInMinutes = (row["Video Length In Minutes"] == undefined ?
                "" :
                row["Video Length In Minutes"]
            )
                .toString()
                .trim();
            var roundTableTopic = (row["Round Table Topic"] == undefined ?
                "" :
                row["Round Table Topic"]
            )
                .toString()
                .trim();
            var sessionTypeIDs = [1, 2, 3, 4, 5];
            sessionTypeId = sessionTypeIDs.includes(sessionTypeId) ?
                sessionTypeId :
                5;
            var sessionTypeDetails = vm.GetSessionTypeDetailsByTypeId(
                sessionTypeId,
                videoURL,
                liveStartDate,
                videoLengthInMinutes,
                roundTableTopic
            );
            docObj.SessionTypeDetails = sessionTypeDetails;
            docObj.DescriptionShort = (row["Short Description"] == undefined ?
                "" :
                row["Short Description"]
            )
                .toString()
                .trim();
            docObj.Description = (row["Long Description"] == undefined ?
                "" :
                row["Long Description"]
            )
                .toString()
                .trim();

            if (docObj.SessionId == "") {
                docObj.SessionId = autoId; //"S" + new Date().getTime();
            }
            debugger;
            for (let i = 0; i < MappedContactsArrTrimmed.length; i++) {
                if (MappedContactsArrTrimmed[i] != "") {
                    var speaker = speakerList.filter(function (value) {
                        return value.data().Email.toLowerCase() == MappedContactsArrTrimmed[i];
                    });
                    if (speaker.length > 0) {
                        speaker = speaker[0];
                        var d = speaker.data();
                        MappedSpeakers.push({
                            //id: speaker.id,
                            AttendeeId: d.SpeakerId,
                            FirstName: d.FirstName,
                            LastName: d.LastName,
                            Name: d.Name,
                            Company: d.Company,
                            Designation: d.Designation,
                            ProfilePictureURL: d.ProfilePictureURL,
                            Phone: d.Phone,
                            Email: d.Email.toLowerCase()
                        });
                    }
                }
            }
            docObj.MappedSpeakers = MappedSpeakers;
            for (let i = 0; i < MappedHostsArrTrimmed.length; i++) {
                if (MappedHostsArrTrimmed[i] != "") {
                    speaker = MappedSpeakers.filter(function (value) {
                        return value.Email.toLowerCase() == MappedHostsArrTrimmed[i];
                    });
                    if (speaker.length > 0) {
                        d = speaker[0];
                        MappedHosts.push({
                            AttendeeId: d.AttendeeId,
                            FirstName: d.FirstName,
                            LastName: d.LastName,
                            Name: d.Name,
                            Company: d.Company,
                            Designation: d.Designation,
                            ProfilePictureURL: d.ProfilePictureURL,
                            Phone: d.Phone,
                            Email: d.Email.toLowerCase()
                        });
                    }
                }
            }
            docObj.MappedHosts = MappedHosts;

            db.eventDB
                .collection(vm.event_collectionName)
                .doc("SessionList")
                .collection("Sessions")
                .doc(docObj.SessionId)
                .get()
                .then(function (doc) {
                    if (!doc.exists) {
                        //console.log('not exist- '+docObj.Email);
                        //docObj.AutoId = vm.GenerateAutoId("session");
                        docObj.IsPublished = true;
                        docObj.CreatedDate = new Date();
                        docObj.LastModifiedDate = new Date();
                        db.eventDB
                            .collection(vm.event_collectionName)
                            .doc("SessionList")
                            .collection("Sessions")
                            .doc(docObj.SessionId)
                            .set(docObj)
                            .then(function () {
                                resolve("Sessions Created : " + docObj.SessionId);
                            })
                            .catch(function (error) {
                                console.error("Error creating Sessions: ", error);
                            });
                    } else {
                        //console.log('exist- '+docObj.Email);
                        docObj.LastModifiedDate = new Date();
                        db.eventDB
                            .collection(vm.event_collectionName)
                            .doc("SessionList")
                            .collection("Sessions")
                            .doc(docObj.SessionId)
                            .update({
                                Name: row["Session Name"],
                                Track: {
                                    TrackID: 0,
                                    TrackName: row["Track Name"].toString().trim()
                                },
                                Location: { LocationID: 0, LocationName: location },
                                Resources: ResourceFiles,
                                //StartDate: new Date(),
                                //EndDate: new Date(),
                                StartDate: startDate,
                                EndDate: endDate,
                                SessionSettings: {
                                    PreRollImageURL: (row["Pre Role Image URL"] == undefined ?
                                        "" :
                                        row["Pre Role Image URL"]
                                    )
                                        .toString()
                                        .trim(),
                                    PostRollImageURL: (row["Post Role Image URL"] == undefined ?
                                        "" :
                                        row["Post Role Image URL"]
                                    )
                                        .toString()
                                        .trim()
                                },
                                SessionTypeDetails: sessionTypeDetails,
                                DescriptionShort: (row["Short Description"] == undefined ?
                                    "" :
                                    row["Short Description"]
                                )
                                    .toString()
                                    .trim(),
                                Description: (row["Long Description"] == undefined ?
                                    "" :
                                    row["Long Description"]
                                )
                                    .toString()
                                    .trim(),
                                MappedSpeakers: MappedSpeakers,
                                MappedHosts: MappedHosts
                            })
                            .then(function () {
                                resolve("Sessions Updated : " + docObj.SessionId);
                            })
                            .catch(function (error) {
                                console.error("Error creating Sessions: ", error);
                            });
                    }
                    //alert("Sessions Created Successfully");
                })
                .catch(function (error) {
                    console.log("Error saving Sessions:", error);
                });
        });
    },
    MapUserWithEvent: function (userId) {
        console.log("22-------------");
        return new Promise((resolve, reject) => {
            var mapObj = new Object();
            mapObj.UserId = userId;
            mapObj.EventIDs = [vm.eventId];
            mapObj.LastModifiedDate = new Date();

            db.collection("OA_UAT")
                .doc("ClientList")
                .collection("Clients")
                .doc(vm.clientId)
                .collection("UserEvents")
                .doc(userId)
                .get()
                .then(function (doc) {
                    if (!doc.exists) {
                        db.collection("OA_UAT")
                            .doc("ClientList")
                            .collection("Clients")
                            .doc(vm.clientId)
                            .collection("UserEvents")
                            .doc(userId)
                            .set(mapObj)
                            .then(function () {
                                console.log("Userevent Created : " + userId);
                                resolve('Userevent Created')
                            })
                            .catch(function (error) {
                                console.error("Error creating user: ", error);
                                reject(error)
                            });
                    } else {

                        db.collection("OA_UAT")
                            .doc("ClientList")
                            .collection("Clients")
                            .doc(vm.clientId)
                            .collection("UserEvents")
                            .doc(userId)
                            .update({
                                EventIDs: firebase.firestore.FieldValue.arrayUnion(vm.eventId)
                            })
                            .then(function () {
                                console.log("Userevent updated : " + userId);
                                resolve('Userevent updated')
                            })
                            .catch(function (error) {
                                console.error("Error creating user: ", error);
                                reject(error)
                            });
                    }
                })
                .catch(function (error) {
                    console.error("Error creating user: ", error);
                });
        })
    },
    AddAttendeeTag: function (tags) {
        console.log("23-------------");
        return new Promise((resolve) => {
            var tagList = (tags == undefined ? "" : tags)
                .toString()
                .trim()
                .split(",");
            tagList = tagList.map(str => str.trim());
            if (tagList.length) {
                let totallength = tagList.length;
                let count = 0;
                for (let i = 0; i < tagList.length; i++) {
                    if (tagList[i] != "") {
                        debugger;
                        var tag = tagList[i];
                        db.eventDB
                            .collection(vm.event_collectionName)
                            .doc("AttendeeTags")
                            .get()
                            .then(function (doc) {
                                if (!doc.exists) {
                                    //docObj.AutoId = vm.GenerateAutoId("exhibitor");
                                    var docObj = new Object();
                                    docObj.Tags = [tag];
                                    docObj.CreatedDate = new Date();
                                    docObj.LastModifiedDate = new Date();
                                    db.eventDB
                                        .collection(vm.event_collectionName)
                                        .doc("AttendeeTags")
                                        .set(docObj)
                                        .then(function () {
                                            console.log("Tag Created : " + tag);
                                            count = count + 1;
                                        })
                                        .catch(function (error) {
                                            console.error("Error creating Tag: ", error);
                                            count = count + 1;
                                        });
                                } else {
                                    db.eventDB
                                        .collection(vm.event_collectionName)
                                        .doc("AttendeeTags")
                                        .update({
                                            Tags: firebase.firestore.FieldValue.arrayUnion(tag),
                                            LastModifiedDate: new Date()
                                        })
                                        .then(function () {
                                            console.log("Tag Updated : " + tag);
                                            count = count + 1;
                                        })
                                        .catch(function (error) {
                                            console.error("Error creating Tag: ", error);
                                            count = count + 1;
                                        });
                                }
                                //alert("Exhibitor Created Successfully");
                            })
                            .catch(function (error) {
                                console.log("Error saving Tag:", error);
                                count = count + 1;
                            });
                        break;
                    } else {
                        count = count + 1;
                    }

                }
                if (totallength == count) {
                    resolve('Tags Created')
                }
            } else {
                resolve('No Tags');
            }
        })
    },
    ProcessAttendeeObj: function (row) {
        console.log("24-------------");
        return new Promise((resolve) => {
            //var email = (row["Email"] == undefined ? "" : row["Email"]).trim();
            var attendeeTags = (row["Tags"] == undefined ? "" : row["Tags"]).trim();
            var docObj = new Object();
            docObj.FirstName = (row["First Name"] == undefined ?
                "" :
                row["First Name"]
            ).trim();
            docObj.LastName = (row["Last Name"] == undefined ?
                "" :
                row["Last Name"]
            ).trim();
            docObj.Name = docObj.FirstName + " " + docObj.LastName;
            docObj.Email = (row["Email"] == undefined ? "" : row["Email"].toLowerCase()).trim();
            docObj.Tags = attendeeTags;
            docObj.Phone = (row["Phone"] == undefined ? "" : row["Phone"])
                .toString()
                .trim();
            docObj.Company = (row["Company"] == undefined ?
                "" :
                row["Company"]
            ).trim();
            docObj.Country = (row["Country"] == undefined ?
                "" :
                row["Country"]
            ).trim();
            docObj.Designation = (row["Title"] == undefined ?
                "" :
                row["Title"]
            ).trim();
            docObj.ProfilePictureURL = (row["Profile Picture URL"] == undefined ?
                "" :
                row["Profile Picture URL"]
            ).trim();
            docObj.Profile = (row["Profile"] == undefined ?
                "" :
                row["Profile"]
            ).trim();
            docObj.Website = (row["Website"] == undefined ?
                "" :
                row["Website"]
            ).trim();
            docObj.ProfilePictureURL = (row["Profile Picture URL"] == undefined ?
                "" :
                row["Profile Picture URL"]
            ).trim();
            docObj.SocialLinks = [{
                Facebook: (row["Facebook"] == undefined ? "" : row["Facebook"]).trim()
            },
            {
                Twitter: (row["Twitter"] == undefined ? "" : row["Twitter"]).trim()
            },
            {
                GooglePlus: (row["GooglePlus"] == undefined ?
                    "" :
                    row["GooglePlus"]
                ).trim()
            },
            {
                LinkedIn: (row["LinkedIn"] == undefined ? "" : row["LinkedIn"]).trim()
            }
            ];
            docObj.ShowInCMSAttendeeList = 1;
            docObj.FormType = "FREE";
            docObj.RegistrationType = {
                ColorCode: "",
                RegistrationType: "Attendee",
                RegistrationTypeId: null
            };
            docObj.MailSent = false;
            docObj.IsVerified = true;
            docObj.IsPublished = true;
            docObj.UserRoles = [{
                RoleID: 10,
                RoleName: "AppUser"
            }];
            docObj.CreatedDate = new Date();
            docObj.LastModifiedDate = new Date();
            resolve(docObj);
        })
    },
    ProcessInviteeObj: function (row) {
        console.log("24-------------");
        return new Promise((resolve) => {
            var docObj = new Object();
            docObj.first_name = (row["First Name"] == undefined ?
                "" :
                row["First Name"]
            ).trim();
            docObj.last_name = (row["Last Name"] == undefined ?
                "" :
                row["Last Name"]
            ).trim();
            docObj.email = (row["Email"] == undefined ? "" : row["Email"].toLowerCase()).trim();

            docObj.company = (row["Company"] == undefined ?
                "" :
                row["Company"]
            ).trim();
            docObj.designation = (row["Designation"] == undefined ?
                "" :
                row["Designation"]
            ).trim();
            docObj.title = (row["Title"] == undefined ?
                "" :
                row["Title"]
            ).trim();


            resolve(docObj);
        })
    },
    AddMultipleAttendee: function (attendees) {
        console.log("25-------------");
        console.log("attendee-------------", attendees);

        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                "x-api-key": DeleteAttendeeApiKey
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": vm.clientId,
                    "eventId": vm.eventId
                },
                "data": attendees,
                "sendMail": 0
            };


            axios.post(AddMultipleAttendeeAPI, requestData, { headers: headers }).then(function (res) {
                if (res.data.status == 0) {
                    let info = {
                        ProgressbarMessage: "Attendee Import",
                        ProgressBarListenerLink: res.data.listen,
                        ImportRefreshLink: "attendees"
                    };
                    console.log(info);
                    store.commit("setBulkUploadProgress", info);


                    //vm.startBulkProgress();

                    // ls.setSessionUserInfo(info);
                    resolve({ status: 200, message: 'Data Added.' })
                }
                else {
                    resolve({ status: 500, message: 'Data Not Added.' })
                }

            }).catch(function (error) {
                reject(error)
            })
        })
    },
    AddMultipleInvitee: function (attendees) {
        console.log("25-------------");
        console.log("attendee-------------", attendees);



        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ` + SessionToken
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": vm.clientId,
                    "eventId": vm.eventId,
                    "sendInvite": 0
                },
                "data": attendees,
            };


            axios.post(InviteAttendeeApiURL, requestData, { headers: headers }).then(function (res) {
                if (res.data.status == 0) {
                    // let info = {
                    //     ProgressbarMessage: "Attendee Import",
                    //     ProgressBarListenerLink: res.data.listen,
                    //     ImportRefreshLink: "attendees"
                    // };
                    // console.log(info);
                    // store.commit("setBulkUploadProgress", info);
                    console.log("res========", res.data);



                    //vm.startBulkProgress();

                    // ls.setSessionUserInfo(info);
                    resolve({ status: 200, message: 'Data Added.' })
                }
                else {
                    resolve({ status: 500, message: 'Data Not Added.' })
                }

            }).catch(function (error) {
                reject(error)
            })
        })
    },
    updateUserbyId(UserObj) {
        console.log("26-------------");
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ` + vm.getSessionToken()
            }
            let requestData = {
                "key": {
                    "eventId": "",
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": UserObj
            }
            axios.post(UpdateUserAPI, requestData, { headers: headers }).then(snapShot => {
                if (snapShot.data.status == 0) {
                    resolve({ status: 200, message: "User Updated" })
                }
                else {
                    resolve({ status: 500, message: "User Not Updated" })
                }
            }).catch(err => { reject(err) })
        })
    },
    getUserDetailbyId(UserId) {
        console.log("27-------------");
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ` + vm.getSessionToken()
            }
            let requestData = {
                "key": {
                    "eventId": "",
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    UserId: `${UserId}`
                }
            }
            axios.post(CheckUserValidAPI, requestData, { headers: headers }).then(snapShot => {
                if (snapShot.data.userStatus) {
                    let doc = snapShot.data.result;
                    resolve(doc)
                }
                else {
                    resolve(null)
                }
            }).catch(err => { reject(err) })
        })
    },
    getUserDetailbyEmail(Email) {
        console.log("28-------------");
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ` + vm.getSessionToken()
            }
            let requestData = {
                "key": {
                    "eventId": "",
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    Email: `${Email}`
                }
            }
            axios.post(CheckUserValidAPI, requestData, { headers: headers }).then(snapShot => {
                if (snapShot.data.userStatus) {
                    let doc = snapShot.data.result;
                    resolve(doc)
                }
                else {
                    resolve(null)
                }
            }).catch(err => { reject(err) })
        })
    },
    createAttendeeUserByAPI(docObj) {
        console.log("29-------------");
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ` + vm.getSessionToken(),
                "x-api-key": DeleteAttendeeApiKey
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id
                },
                "data": docObj,
                "sendMail": 0
            };
            axios.post(AddSingleAttendeeAPI, requestData, { headers: headers }).then(res => {
                if (res.status == 200) {
                    resolve({ status: 200, message: 'Data Added.' })
                }
                else {
                    resolve({ status: 500, message: 'Data Not Added.' })
                }
            }).catch(err => { reject(err) })
        })
    },

}


export default vm;